import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '90%',
    maxHeight: '80vh',
    margin: 'auto auto',
    outline: ' none',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[2],
    borderRadius: 12,
    minHeight: 250,
    display: 'flex',
  },
  card: {
    borderRadius: 12,
    minHeight: '100%',
    minWidth: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  action: {
    margin: theme.spacing(0),
  },
  header: {
    padding: theme.spacing(0, 2),
  },
  cardContent: {
    padding: theme.spacing(2),
  },
  titleClass: {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.main,
    fontStyle: 'italic',
  },

  closeButton: {
    color: theme.palette.text.main,
  },
}))
